import React from 'react';
import { Button, Empty, Input, Select } from 'antd';
import { BsPlusLg } from 'react-icons/bs';
import { PageLoader } from '@pages/api-portal/page-loader';
import { API_HTTP_METHODS } from '@pages/api-portal/constants';
import { useEndpointsManager } from './use-endpoints-manager';
import { EndpointRow } from './endpoint-row';
import { EndpointFormDialog } from './endpoint-dialog';

/*
 * API Endpoints manager — search/group/method filters, create/edit/delete endpoint metadata.
 */
export function EndpointsManager() {
    const {
        groups,
        isLoading,
        searchQuery,
        setSearchQuery,
        filterGroup,
        setFilterGroup,
        filterMethod,
        setFilterMethod,
        filteredEndpoints,
        isFormDialogOpen,
        setIsFormDialogOpen,
        selectedEndpoint,
        openCreateDialog,
        openEditDialog,
        handleSubmit,
        handleDeleteRequest,
    } = useEndpointsManager();

    return (
        <div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
                <Input.Search
                    placeholder="Search endpoints"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ maxWidth: 260 }}
                    allowClear
                />
                <Select
                    placeholder="All groups"
                    style={{ width: 180 }}
                    allowClear
                    value={filterGroup ?? undefined}
                    onChange={(value: string) => setFilterGroup(value ?? null)}
                >
                    {groups.map((g) => (
                        <Select.Option key={String(g.id)} value={g.groupKey ?? String(g.id)}>
                            {g.name}
                        </Select.Option>
                    ))}
                </Select>
                <Select
                    placeholder="All methods"
                    style={{ width: 140 }}
                    allowClear
                    value={filterMethod ?? undefined}
                    onChange={(value: string) => setFilterMethod(value ?? null)}
                >
                    {API_HTTP_METHODS.map((m) => (
                        <Select.Option key={m} value={m}>
                            {m}
                        </Select.Option>
                    ))}
                </Select>
                <Button type="primary" onClick={openCreateDialog} style={{ marginLeft: 'auto' }}>
                    <BsPlusLg style={{ marginRight: 6 }} />
                    Create Endpoint
                </Button>
            </div>

            {isLoading ? (
                <PageLoader />
            ) : filteredEndpoints.length === 0 ? (
                <Empty description={searchQuery || filterGroup || filterMethod ? 'No endpoints found' : 'No endpoints yet'}>
                    {!searchQuery && !filterGroup && !filterMethod && (
                        <Button onClick={openCreateDialog}>
                            <BsPlusLg style={{ marginRight: 6 }} />
                            Create Endpoint
                        </Button>
                    )}
                </Empty>
            ) : (
                filteredEndpoints.map((endpoint) => (
                    <EndpointRow key={endpoint.id} endpoint={endpoint} onEdit={openEditDialog} onDelete={handleDeleteRequest} />
                ))
            )}

            <EndpointFormDialog
                open={isFormDialogOpen}
                onClose={() => setIsFormDialogOpen(false)}
                onSubmit={handleSubmit}
                groups={groups}
                endpoint={selectedEndpoint}
            />
        </div>
    );
}
